module.exports = __webpack_public_path__ + "img/salReg.c03bd3bd.svg";